import styled from 'styled-components';

import { GridContainer, GridItem } from '@xing-com/grid';
import { mediaWideNavless } from '@xing-com/layout-tokens';
import { spaceL, spaceXS, spaceXXL } from '@xing-com/tokens';

export const HeaderContainer = styled(GridItem)`
  display: flex;
  flex-direction: column;
  gap: ${spaceXS};
`;

export const SectionGridContainer = styled(GridContainer)`
  padding: 0 ${spaceL} 0 ${spaceL};
  max-width: 1520px;
  width: 100%;
  gap: ${spaceXXL} 0px;
`;

export const ButtonContainer = styled(GridItem)`
  display: flex;
  justify-content: start;
  align-items: start;
  @media ${mediaWideNavless} {
    justify-content: end;
  }
`;

export const HeadlineElements = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${spaceL};
  width: 100%;
`;
